export default "__VITE_ASSET__Cye$zPuK__"